angular.module('app').directive('formGroupDefault', ["$compile", function ($compile) {
  return {
    restrict: 'C',
    link: function (scope, element, attrs) {
      var labelObserver;
      function processLabel($lbl) {
        var labelEl = $lbl[0];
        if (labelEl.pgTruncProcessed) return;
        labelEl.pgTruncProcessed = true;
        if (labelEl.style.display) return;
        var preserveFrom = null;
        var hasNgIfPlaceholders = false;
        var anchor = null;
        for (var i = labelEl.childNodes.length - 1; i >= 0; i--) {
          var node = labelEl.childNodes[i];
          if (node.nodeType === Node.ELEMENT_NODE) {
            preserveFrom = node;
          } else if (node.nodeType === Node.COMMENT_NODE) {
            hasNgIfPlaceholders = true;
          } else if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            anchor = node.nextSibling;
            break;
          }
        }
        if (!preserveFrom && labelEl.children.length) return;
        var textSpan = document.createElement('span');
        textSpan.className = 'form-group-label-text';
        var child = labelEl.firstChild;
        while (child && child !== anchor) {
          var next = child.nextSibling;
          if (child.nodeType === Node.TEXT_NODE) {
            textSpan.appendChild(child);
          }
          child = next;
        }
        if (!textSpan.childNodes.length) return;
        labelEl.insertBefore(textSpan, anchor);
        $lbl.addClass('has-label-text');
        if (preserveFrom || hasNgIfPlaceholders) {
          $lbl.addClass('has-label-suffix');
        }
        var ttScope = null;
        textSpan.addEventListener('mouseenter', function () {
          if (ttScope) {
            ttScope.pgTruncTooltipEnabled = textSpan.scrollWidth > textSpan.offsetWidth;
            ttScope.pgTruncTooltipText = textSpan.textContent.trim();
            return;
          }
          if (textSpan.scrollWidth <= textSpan.offsetWidth) return;
          var text = textSpan.textContent.trim();
          if (!text) return;
          ttScope = scope.$new();
          ttScope.pgTruncTooltipEnabled = true;
          ttScope.pgTruncTooltipText = text;
          labelEl.pgTruncTooltipScope = ttScope;
          var $textSpan = angular.element(textSpan);
          $textSpan.attr('smart-tooltip', '{{pgTruncTooltipText}}');
          $textSpan.attr('tooltip-enable', 'pgTruncTooltipEnabled');
          $textSpan.attr('tooltip-append-to-body', 'true');
          var textNodes = document.createDocumentFragment();
          while (textSpan.firstChild) {
            textNodes.appendChild(textSpan.firstChild);
          }
          $compile($textSpan)(ttScope);
          textSpan.appendChild(textNodes);
          if (!scope.$root.$$phase) ttScope.$digest();
          $textSpan.triggerHandler('mouseenter');
        });
        textSpan.addEventListener('mouseleave', function () {
          if (ttScope) ttScope.pgTruncTooltipEnabled = false;
        });
      }
      function hasTrailingContent(node) {
        for (var n = node.nextSibling; n; n = n.nextSibling) {
          if (n.nodeType === Node.ELEMENT_NODE || n.nodeType === Node.COMMENT_NODE) return true;
          if (n.nodeType === Node.TEXT_NODE && n.textContent.trim()) return true;
        }
        return false;
      }
      function claimLabel($lbl) {
        if ($lbl.hasClass('inline')) {
          var $control = $lbl.next('.inline');
          if (!$control.children('.checkbox').length || hasTrailingContent($control[0])) return;
          element.addClass('form-group-default--checkbox-row');
        }
        processLabel($lbl);
      }
      var $truncLabel = element.children('label').first();
      if ($truncLabel.length) {
        claimLabel($truncLabel);
      }
      if (typeof MutationObserver !== 'undefined' && !$truncLabel.length) {
        labelObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            Array.prototype.forEach.call(mutation.removedNodes, function (node) {
              if (node.pgTruncTooltipScope) {
                node.pgTruncTooltipScope.$destroy();
                node.pgTruncTooltipScope = null;
              }
            });
          });
          var $lbl = element.children('label').first();
          if ($lbl.length) {
            claimLabel($lbl);
          }
        });
        labelObserver.observe(element[0], {
          childList: true
        });
      }
      scope.$on("$destroy", function () {
        if (labelObserver) labelObserver.disconnect();
      });
    }
  };
}]);